import React from 'react';
const JourneyBarLastStep = ({ name, width, style }) => {
    const x1 = width - 10;
    const pnts = `0 0,${x1} 0,${x1} 30,0 30,10 15,0 0`;
    return (
        <>
            {' '}
            <svg
                id={name}
                data-name={name}
                xmlns='http://www.w3.org/2000/svg'
                width={width}
                height='30'
                viewBox={'0 0 ' + width + ' 30'}
                fill={style.fill}
                stroke={style.stroke}
            >
                <polygon points={pnts} />
                <rect x={x1 - 10} rx='8' ry='8' width='20' height='30' />
                <rect
                    x={x1 - 15}
                    y='1'
                    width='10'
                    height='28'
                    strokeWidth='0'
                />
            </svg>
        </>
    );
};
export default JourneyBarLastStep;
